module.exports = __webpack_public_path__ + "img/digitalis_atallas.5972aef2.png";